import React from 'react';
import ProgressBar from "@Generic/loaders/ProgressBar";
import {RatingType} from "@Pages/reviews/types/Rating.type";

interface UserRatingProps {
    value: number,
    label: string,
    onClick: (rating: RatingType) => void,
    rating: RatingType,
    activeRatings: []
}

function UserRating({value, label, onClick, rating, activeRatings}: UserRatingProps) {
    return (
        <div className="gb--rating-property">
            <div className="md-checkbox">
                <input
                    key={`userRating${label}`}
                    id={`userRating${label}`}
                    name={`userRating${label}`}
                    type="checkbox"
                    checked={activeRatings.includes(rating)}
                    // Return null to silence react error.
                    // we're using label as change handler instead of checkbox
                    onChange={() => null}
                />
                <button
                    type="button"
                    className="gb--rating-label"
                    onClick={() => {
                        onClick(rating)
                    }}
                >
                    {label}
                </button>
            </div>
            <ProgressBar percentage={value} displaySign displayValue/>
        </div>
    );
}

export default UserRating;